import React, { useEffect, useState } from 'react'
import { getData, putData } from '../../../actions/servicesHttp'
import Button from 'react-bootstrap/Button'
import Header from '../../../components/generals/header'
import Loading from '../../../components/generals/loading'
import Swal from 'sweetalert2'
import { compareObj } from '../../../components/generals/toolsFunctions'
import store from '../../../reducer/store'
import styles from '../../../css/preferences/Notifications.module.css'
import stylesIndex from '../../../css/Index.module.css'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function GeofencesPreferences () {
  const [inputData, setInputData] = useState({})
  const [settingsToCompare, setSettingsToCompare] = useState({})
  const { user } = store.getState()
  const role = user.roles
  const { t } = useTranslation('geofencesPreferences')
  const navigate = useNavigate()

  const handleInputChange = ({ target }) => {
    setInputData({
      ...inputData,
      [target.name]: target.type === 'checkbox' ? target.checked : target.value
    })
  }

  useEffect(() => {
    const getConfig = async () => {
      const { data } = await getData('config-geofence', 1, navigate)
      if (data) {
        setSettingsToCompare(data)
        setInputData(data)
      }
    }
    getConfig()
  }, [])

  const addConfigGeo = async () => {
    try {
      const date = new Date().toISOString()
      const compareData = compareObj(inputData, settingsToCompare)

      if (compareData) {
        Swal.fire({
          position: 'center',
          icon: 'info',
          title: t('message1'),
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        setInputData({ ...inputData, date })

        const { data } = await putData('config-geofence', inputData, navigate)

        if (data?.result === true) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: t('message2'),
            showConfirmButton: false,
            timer: 1500
          })
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: t('message3'),
            showConfirmButton: false,
            timer: 1500
          })
        }
      }
      setSettingsToCompare(inputData)
    } catch (error) {
      console.error('Error al enviar la solicitud de guardado:', error)
    }
  }

  if (Object.keys(inputData).length === 0) {
    return (
      <div className="content-wrapper containerHeight">
        <Loading color="primary" />
      </div>
    )
  } else {
    return (
      <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
        <div className={`content  ${stylesIndex.mainContent}`}>
          <Header title={t('title')} className={styles.title} />
          {role?.preferencesGeofencePage.notificationsGeofences &&
          <>
            <div className={styles.containerCheckbox}>
              <label className={styles.switch}>
                <input
                  type="checkbox"
                  name="checkEmail"
                  onChange={handleInputChange}
                  value={inputData?.checkEmail}
                  checked={inputData?.checkEmail}
                />
                <span className="slider round"></span>
              </label>
              <label className={styles.labelNotifications} htmlFor="checkEmail">
                {t('label1')}
              </label>
              <br />

              <label className={styles.switch}>
                <input
                  type="checkbox"
                  name="checkSms"
                  onChange={handleInputChange}
                  value={inputData?.checkSms}
                  checked={inputData?.checkSms}
                />
                <span className="slider round"></span>
              </label>
              <label className={styles.labelNotifications} htmlFor="checkSms">
                {t('label2')}
              </label>
              <br />
            </div>

            <h6 className={styles.subtitleNotif}>
              {t('label3')}
            </h6>

            <select
              className={styles.selectNotif}
              name="notifications"
              value={inputData?.notifications}
              onChange={handleInputChange}
            >
              <option value={t('option1')}>{t('option1')}</option>
              <option value={t('option2')}>{t('option2')}</option>
            </select>
            <br />
          </>}

          {role?.preferencesGeofencePage.actionsGeofences &&
          <>
            <h6 className={styles.subtitleAction}>{t('label4')}</h6>
            <hr className={styles.custom_hr} />

            <h6 className={styles.subtitleConfig}>
              {t('label5')}
            </h6>

            <div className={styles.container_custom_checkbox}>
              <div className={styles.divInputText}>
                <p className={styles.checkboxText}>{t('label6')}</p>
                <input
                  className={styles.inputText}
                  type="text"
                  name="sendMsg"
                  value={inputData?.sendMsg}
                  onChange={handleInputChange}
                />
              </div>

              {/* <label className={styles.customCheckbox}>
                <input
                  type="checkbox"
                  name="activeNetwork"
                  value={inputData?.activeNetwork}
                  checked={inputData?.activeNetwork}
                  onChange={handleInputChange}
                />
                <p className={styles.checkboxText}>
                  Activar/Desactivar Conexiones de Red
                </p>
              </label> */}

              <label className={styles.customCheckbox}>
                <input
                  /* className="custom-input" */
                  type="checkbox"
                  name="activeDevice"
                  value={inputData?.activeDevice}
                  checked={inputData?.activeDevice}
                  onChange={handleInputChange}
                />
                <p className={styles.checkboxText}>{t('label7')}</p>
              </label>

              <label className={styles.customCheckbox}>
                <input
                  /* className="custom-input" */
                  type="checkbox"
                  name="powerOffDevice"
                  value={inputData?.powerOffDevice}
                  checked={inputData?.powerOffDevice}
                  onChange={handleInputChange}
                />
                <p className={styles.checkboxText}>{t('label8')}</p>
              </label>
            </div>
            <br />
          </>}

          {role?.preferencesGeofencePage.historyGeofences &&
          <>
            <h6 className={styles.subtitleGeo}>{t('label9')}</h6>
            <hr className={styles.custom_hr} />

            <h6 className={styles.subtitleConfig}>
              {t('label10')}
            </h6>

            <select
              className={styles.selectDate}
              name="selectDate"
              value={inputData?.selectDate}
              onChange={handleInputChange}
            >
              <option value={t('option3')}>{t('option3')}</option>
              <option value={t('option4')}>{t('option4')}</option>
              <option value={t('option5')}>{t('option5')}</option>
            </select>
            <br />

            <div className={styles.containerCheckbox}>
              <label className={styles.switch}>
                <input
                  type="checkbox"
                  name="exportData"
                  onChange={handleInputChange}
                  value={inputData?.exportData}
                  checked={inputData?.exportData}
                />
                <span className="slider round"></span>
              </label>
              <label className={styles.labelNotifications} htmlFor="exportData">
                {t('label11')}
              </label>
            </div>
          </>}

          <div className={styles.container_btn}>
            <Button variant="dark" className={styles.buttonSave} onClick={addConfigGeo} id="btnSaveConfig">
              <i className="fas fa-save" style={{ marginRight: '0.5rem' }}></i>
              {t('button')}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}
